import { render, staticRenderFns } from "./ProductSeoForm.vue?vue&type=template&id=e0048678&"
import script from "./ProductSeoForm.vue?vue&type=script&lang=js&"
export * from "./ProductSeoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports